import { Box, Grid, Skeleton } from "@mui/material";
import React from "react";

export const SkeletonArticulosKiosk = () => {
  return (
    <Grid container spacing={2}>
      {Array.from(new Array(9)).map((_, index) => (
        <Grid item xs={4} key={index}>
          <Box
            key={index}
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          backgroundColor: "#FFFFFF",
          borderRadius: "4px",
          p: 2,
          margin: 1,
          width: 250,
          height: 400,
          boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
        }}
          >
            <Box sx={{display: "flex", justifyContent: "flex-end", mb: 1, mr:-14}}>
              <Skeleton variant="text" width="100px" height="40px" />
            </Box>
            <Skeleton variant="rectangular" width={200} height={220} sx={{ borderRadius: 2 }} />
            <Skeleton variant="text" width="150px" height="40px" sx={{ mt: 2 }} />
            <Box sx={{ display: "flex",  justifyContent: "space-between", mt: 1 }}>
              <Skeleton variant="text" width="30px" height="40px" sx={{ml:-10}}/>
              <Skeleton variant="text" width="30px" height="40px" sx={{mr:1, ml:10}}/>
              <Skeleton variant="text" width="10px" height="40px" sx={{mr:1}}/>
              <Skeleton variant="text" width="30px" height="40px" sx={{mr:-10}}/>
            </Box>
            {/* <Box sx={{ ml: 1, flex: 1 }}>
              <Skeleton variant="text" width="40px" height="15px" />
              <Skeleton variant="text" width="50px" height="15px" sx={{mt:-0.5}} />
              <Skeleton variant="text" width="50px" height="15px" sx={{mt:-0.5}} />
            </Box>
            <Skeleton variant="text" width="40px" sx={{ mr: 1 }} />
            <Skeleton variant="circular" width="20px" sx={{ mr: 0.5 }} />
            <Skeleton variant="rounded" width="20px" sx={{ mr: 0.5 }} />
            <Skeleton variant="circular" width="20px" sx={{ mr: 1 }} />
            <Skeleton variant="rounded" width="20px" sx={{ mr: 2 }} /> */}
          </Box>
        </Grid>
      ))}
    </Grid>
  );
};
